export default "<m-sphere\n    color=\"yellow\"\n    y=\"3\"\n    sx=\"3\"\n    sy=\"2\"\n    sz=\"3\"\n></m-sphere>\n";